// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"557204b5","53":"0c9295e3","89":"97e9416b","90":"69d0c372","107":"ada93f95","204":"33b1ca50","339":"d788ba0a","404":"ce48412c","442":"5be595e2","457":"7f829c69","460":"5fa23de8","473":"a4f9a0aa","539":"6f77a041","656":"9c3e1769","738":"0bb09b29"}[chunkId] + ".chunk.js";
};